import { registerViewMount } from './navigation.js';
import { appendTrustedAdminViewFragment } from './trusted-admin-view-fragment.js';

let mountPromise = null;

export function initFeishuSyncCenterViewFragment({ onMounted } = {}) {
  registerViewMount('admin-feishu-sync', async () => {
    if (document.getElementById('view-admin-feishu-sync')) return;
    if (!mountPromise) {
      mountPromise = appendTrustedAdminViewFragment(
        document.getElementById('admin-lazy-view-host'),
        '/admin-views/feishu-sync-center.html',
        'Unable to load Feishu sync center',
      ).then(() => onMounted?.());
    }
    return mountPromise;
  });
}
